



































































import { MyChartVue } from "../vueModels/app/MyChartVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class MyChart extends MyChartVue {
  mounted() {
    /** Вызов рендера диаграммы при наличии входных данных */
    if (this.inputData !== undefined && this.inputData.length > 0) {
      this.chartRender();
    }
  }
  beforeDestroy() {
    if (!this.onlyLine)
      this.chart.dispose();
  }
}
